export default __webpack_public_path__ + "static/media/Second _Chance.38f6b389.mp3";